<template>
	<div class="bg">
		<div class="search-container">
			<div style="font-size: 16px; font-weight: bold; padding-bottom: 16px;">查询奖券</div>
			<div class="search-form">
				<div class="input-wrapper">
					<label class="input-label">序列号：</label>
					<el-input v-model="searchParams.prizeCodeLike" placeholder="请输入序列号" clearable
						style="background-color: #F2F3F5;" @keyup.enter.native="handleSearch" />
				</div>
				<div class="input-wrapper">
					<label class="input-label">中奖人：</label>
					<el-input v-model="searchParams.memberNicknameLike" placeholder="请输入中奖人昵称" clearable
						style="background-color: #F2F3F5;" @keyup.enter.native="handleSearch" />
				</div>
				<div class="input-wrapper">
					<label class="input-label">联系号码：</label>
					<el-input v-model="searchParams.memberMobileLike" placeholder="请输入联系号码" clearable
						style="background-color: #F2F3F5;" @keyup.enter.native="handleSearch" />
				</div>
				<div class="divider"></div>
				<div class="search flexc" style="cursor: pointer;" @click="handleSearch">
					<img src="/images/goodsList/search.svg" width="14px" height="14px" alt="" />
					<div style="margin-left: 4px; font-size: 14px;">查询</div>
				</div>
				<div class="reset flexc" style="cursor: pointer;" @click="handleReset">
					<div style="margin-left: 4px; font-size: 14px;">重置</div>
				</div>
			</div>
		</div>

		<div style="margin-top: 20px;">
			<el-table class="custom-header-table" v-loading="tableLoading" :data="prizeUserList">
				<el-table-column type="index" label="序号" width="70" align="center" :index="getTableIndex"></el-table-column>
				<el-table-column label="奖券类型" align="center">
					<template slot-scope="scope">
						<div>{{ getPrizeTypeText(scope.row.type) }}</div>
					</template>
				</el-table-column>
				<el-table-column label="奖品内容" min-width="180" align="center" show-overflow-tooltip>
					<template slot-scope="scope">
						<div>{{ formatCellText(scope.row.lotteryPrizeName) }}</div>
					</template>
				</el-table-column>
				<el-table-column label="有效期" min-width="280" align="center">
					<template slot-scope="scope">
						<div>{{ formatValidityPeriod(scope.row) }}</div>
					</template>
				</el-table-column>
				<el-table-column label="序列号" min-width="180" align="center">
					<template slot-scope="scope">
						<div>{{ formatCellText(scope.row.prizeCode) }}</div>
					</template>
				</el-table-column>
				<el-table-column label="中奖人" align="center">
					<template slot-scope="scope">
						<div>{{ formatCellText(scope.row.memberNickname) }}</div>
					</template>
				</el-table-column>
				<el-table-column label="联系号码" min-width="130" align="center">
					<template slot-scope="scope">
						<div>{{ formatCellText(scope.row.memberMobile) }}</div>
					</template>
				</el-table-column>
				<el-table-column label="核销状态" width="110" align="center">
					<template slot-scope="scope">
						<span :class="['status-tag', getVerifyStatusClass(scope.row)]">
							{{ getVerifyStatusText(scope.row) }}
						</span>
					</template>
				</el-table-column>
				<el-table-column label="操作" width="110" align="center" fixed="right">
					<template slot-scope="scope">
						<div v-if="canVerify(scope.row)"
							class="action action-primary"
							:class="{ 'action-loading': verifyingPrizeCode === scope.row.prizeCode }"
							@click="handleVerify(scope.row)">
							<i v-if="verifyingPrizeCode === scope.row.prizeCode" class="el-icon-loading" style="margin-right: 4px;"></i>
							{{ verifyingPrizeCode === scope.row.prizeCode ? '处理中' : '核销' }}
						</div>
						<div v-else class="action-text">{{ getVerifyStatusText(scope.row) }}</div>
					</template>
				</el-table-column>
			</el-table>

			<div class="flexe" style="margin-top: 12px;">
				<el-pagination
					@size-change="handleSizeChange"
					@current-change="handleCurrentChange"
					:current-page="pagination.currentPage"
					:page-sizes="[10, 20, 30, 40]"
					:page-size="pagination.pageSize"
					layout="total, sizes, prev, pager, next, jumper"
					:total="pagination.total"
					background>
				</el-pagination>
			</div>
		</div>

	</div>
</template>

<script>
	import {
		coupon
	} from '@/api';

	export default {
		data() {
			return {
				tableLoading: false,
				verifyingPrizeCode: '',
				searchParams: {
					prizeCodeLike: '',
					memberNicknameLike: '',
					memberMobileLike: ''
				},
				pagination: {
					currentPage: 1,
					pageSize: 10,
					total: 0
				},
				prizeUserList: []
			};
		},
		created() {
			this.getPrizeUserList();
		},
		methods: {
			handleSearch() {
				this.pagination.currentPage = 1;
				this.getPrizeUserList();
			},
			handleReset() {
				this.searchParams = {
					prizeCodeLike: '',
					memberNicknameLike: '',
					memberMobileLike: ''
				};
				this.pagination.currentPage = 1;
				this.getPrizeUserList();
			},
			handleSizeChange(pageSize) {
				this.pagination.pageSize = pageSize;
				this.pagination.currentPage = 1;
				this.getPrizeUserList();
			},
			handleCurrentChange(currentPage) {
				this.pagination.currentPage = currentPage;
				this.getPrizeUserList();
			},
			getTableIndex(index) {
				return (this.pagination.currentPage - 1) * this.pagination.pageSize + index + 1;
			},
			formatCellText(value) {
				return value === 0 ? 0 : (value || '--');
			},
			getPrizeTypeText(type) {
				const typeMap = {
					1: '优惠券',
					2: '免费券'
				};
				return typeMap[type] || '其它';
			},
			parseDate(value) {
				if (!value) {
					return null;
				}
				if (value instanceof Date) {
					return Number.isNaN(value.getTime()) ? null : value;
				}
				if (typeof value === 'number') {
					const date = new Date(value);
					return Number.isNaN(date.getTime()) ? null : date;
				}
				if (typeof value === 'string') {
					const normalized = value.replace('T', ' ').replace(/\.\d+$/, '');
					const parsed = new Date(normalized.replace(/-/g, '/'));
					if (!Number.isNaN(parsed.getTime())) {
						return parsed;
					}
					const fallback = new Date(value);
					return Number.isNaN(fallback.getTime()) ? null : fallback;
				}
				return null;
			},
			formatDateTime(value) {
				if (!value) {
					return '--';
				}
				const date = this.parseDate(value);
				if (!date) {
					return this.formatCellText(value);
				}
				const year = date.getFullYear();
				const month = String(date.getMonth() + 1).padStart(2, '0');
				const day = String(date.getDate()).padStart(2, '0');
				const hours = String(date.getHours()).padStart(2, '0');
				const minutes = String(date.getMinutes()).padStart(2, '0');
				const seconds = String(date.getSeconds()).padStart(2, '0');
				return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
			},
			formatValidityPeriod(row) {
				const start = this.formatDateTime(row.prizeEffectiveTime);
				const end = this.formatDateTime(row.prizeExpirationTime);
				if (start === '--' && end === '--') {
					return '--';
				}
				return `${start} ~ ${end}`;
			},
			isExpired(row) {
				const expirationDate = this.parseDate(row.prizeExpirationTime);
				if (!expirationDate) {
					return false;
				}
				return Date.now() > expirationDate.getTime();
			},
			getVerifyStatusText(row) {
				if (Number(row.verifyUseFlag) === 1) {
					return '已核销';
				}
				if (this.isExpired(row)) {
					return '已过期';
				}
				return '未核销';
			},
			getVerifyStatusClass(row) {
				const status = this.getVerifyStatusText(row);
				if (status === '已核销') {
					return 'status-success';
				}
				if (status === '已过期') {
					return 'status-expired';
				}
				return 'status-pending';
			},
			canVerify(row) {
				return Number(row.verifyUseFlag) !== 1 && !this.isExpired(row) && !!row.prizeCode;
			},
			async getPrizeUserList() {
				this.tableLoading = true;
				try {
					const params = {
						pageNo: this.pagination.currentPage,
						pageSize: this.pagination.pageSize
					};
					if (this.searchParams.prizeCodeLike) {
						params.prizeCodeLike = this.searchParams.prizeCodeLike.trim();
					}
					if (this.searchParams.memberNicknameLike) {
						params.memberNicknameLike = this.searchParams.memberNicknameLike.trim();
					}
					if (this.searchParams.memberMobileLike) {
						params.memberMobileLike = this.searchParams.memberMobileLike.trim();
					}

					const response = await coupon.queryActivityPrizeUser(params);
					if ((response.code === 0 || response.code === 200) && response.data) {
						this.prizeUserList = response.data.list || [];
						this.pagination.total = response.data.total || 0;

						if (this.prizeUserList.length === 0 && this.pagination.currentPage > 1) {
							this.pagination.currentPage -= 1;
							this.getPrizeUserList();
							return;
						}
					} else {
						this.$message.error(response.msg || '获取奖券列表失败');
					}
				} catch (error) {
					console.error('获取奖券列表错误:', error);
					this.$message.error('网络异常，无法获取奖券列表');
				} finally {
					this.tableLoading = false;
				}
			},
			async handleVerify(row) {
				if (!this.canVerify(row)) {
					return;
				}
				const prizeCode = row.prizeCode;
				try {
					await this.$confirm(`确定核销奖券【${prizeCode}】吗？`, '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					});

					this.verifyingPrizeCode = prizeCode;
					const response = await coupon.verifyAndUsePrize(prizeCode);
					if (response.code === 0 || response.code === 200) {
						this.$message.success('核销成功');
						this.getPrizeUserList();
					} else {
						this.$message.error(response.msg || '核销失败');
					}
				} catch (error) {
					if (error !== 'cancel') {
						console.error('核销奖券错误:', error);
						this.$message.error('核销失败，请稍后重试');
					}
				} finally {
					this.verifyingPrizeCode = '';
				}
			}
		}
	};
</script>

<style scoped>
	.status-tag {
		display: inline-block;
		padding: 2px 8px;
		border-radius: 12px;
		font-size: 12px;
		line-height: 18px;
	}

	.status-pending {
		color: #FA8C16;
		background: rgba(250, 140, 22, 0.12);
	}

	.status-success {
		color: #00B42A;
		background: rgba(0, 180, 42, 0.12);
	}

	.status-expired {
		color: #F53F3F;
		background: rgba(245, 63, 63, 0.12);
	}

	.action {
		cursor: pointer;
	}

	.action-primary {
		color: #00B42A;
	}

	.action-loading {
		opacity: 0.6;
		pointer-events: none;
	}

	.action-text {
		color: #86909C;
	}
</style>
